import { useEffect } from 'react';

import { Navigate, useNavigate } from 'react-router-dom';

import { nonceLogin } from 'apis/hcp/users.api';
import { ErrorSeverity, handleError } from 'services/errorService';

const Nonceroute = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
  const nonce = urlParams.get('nonce');
  const siginkey = urlParams.get('signinkey');
  const service = urlParams.get('service');
  const region = urlParams.get('region') ?? 'US';
  const validateAuthetication = async (
    nonce: string | null,
    siginkey: string | null,
    service: string | '',
    region: string | ''
  ) => {
    try {
      if (siginkey) {
        nonceLogin(nonce, siginkey, service, region);
      } else {
        if (!localStorage.getItem('session')) {
          window.location.replace('/signin');
        }
      }
    } catch (error) {
      handleError(error, ErrorSeverity.CRITICAL, {
        source: 'NonceRoute',
        operation: 'nonce authentication',
      });
      navigate('/signin', { replace: true });
    }
  };

  useEffect(() => {
    if (nonce && siginkey && service) validateAuthetication(nonce, siginkey, service, region);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nonce, siginkey, service, region]);

  if (!nonce || !siginkey || !service) return <Navigate replace to="/signin" />;

  return children;
};

export default Nonceroute;
